/**
 * Slider dei prodotti complementari.
 *
 * Niente loop: i cloni di Swiper duplicavano le quick view modal (da cui il
 * vecchio fixQuickviewDuplicate, che rimuovendole rompeva il quick view sulle
 * slide clonate) e con 3-4 prodotti il loop salta. Le colonne arrivano dai data
 * attribute del blocco, watchOverflow disattiva da solo lo slider quando le
 * slide ci stanno tutte.
 */
if (!customElements.get('complementary-product-slider')) {
  customElements.define(
    'complementary-product-slider',
    class ComplementaryProductSlider extends HTMLElement {
      connectedCallback() {
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.productsWrap = this.querySelector('.products-wrap');
        this.products = this.querySelector('.products');
        if (!this.productsWrap || !this.products) return;

        this.enableSliderDesktop = this.dataset.enableSliderDesktop === 'true';
        this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
        this.carousel = null;

        this.onMediaChange = this.update.bind(this);
        this.mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        this.mql.addEventListener('change', this.onMediaChange);

        this.update();
      }

      disconnectedCallback() {
        this.mql?.removeEventListener('change', this.onMediaChange);
        this.destroySlider();
      }

      update() {
        const enabled = FoxTheme.config.mqlMobile ? this.enableSliderMobile : this.enableSliderDesktop;
        enabled ? this.initSlider() : this.destroySlider();
      }

      columnsFrom(value, fallback) {
        if (value === 'auto') return 'auto';
        const columns = parseFloat(value);
        return Number.isFinite(columns) && columns > 0 ? columns : fallback;
      }

      get spaceBetween() {
        const gap = getComputedStyle(this.products).getPropertyValue('--f-column-gap');
        const rem = parseFloat(gap);
        return Number.isFinite(rem) ? rem * 10 : 12;
      }

      initSlider() {
        if (this.carousel) return;

        const options = {
          slidesPerView: this.columnsFrom(this.dataset.columnsMobile, 1),
          spaceBetween: this.spaceBetween,
          loop: false,
          watchOverflow: true,
          threshold: 4,
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          },
          breakpoints: {
            768: { slidesPerView: this.columnsFrom(this.dataset.columnsTablet, 2) },
            1000: { slidesPerView: this.columnsFrom(this.dataset.columnsDesktopsm, 2) },
            1600: { slidesPerView: this.columnsFrom(this.dataset.columnsDesktopl, 3) },
            1800: { slidesPerView: this.columnsFrom(this.dataset.columnsDesktop, 3) },
          },
        };

        const paginationEl = this.querySelector('.swiper-pagination');
        if (paginationEl) {
          options.pagination = { el: paginationEl, clickable: true, type: 'fraction' };
        }

        this.productsWrap.classList.add(this.classes.swiper);
        this.products.classList.remove(this.classes.grid);
        this.products.classList.add(this.classes.swiperWrapper);

        this.carousel = new window.FoxTheme.Carousel(this.productsWrap, options);
        this.carousel.init();
      }

      destroySlider() {
        this.productsWrap.classList.remove(this.classes.swiper);
        this.products.classList.remove(this.classes.swiperWrapper);
        this.products.classList.add(this.classes.grid);

        if (!this.carousel) return;
        this.carousel.slider?.destroy(true, true);
        this.carousel = null;
      }
    }
  );
}
